import { Show, useRecordContext } from "react-admin";
import { useNavigate } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { useState } from "react";

//Events
import EventBus from "../../EventBus";

//Enum
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";

//Services
import { CuisineDishService } from "../../services/CuisineDishService";

//Common styles
import { SectionTitleRow, TabsContainer, WorkspaceContainer, WorkspaceHeader, WorkspaceTitle } from "../../styles/commonStyles";

//Svg
import { CuisineIcon } from "../Svg/CuisineIcon";

//Common colors
import { colors } from "../../styles/colors";

//Common Components
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import UploadDishImageDialog from "../Common/UploadDishImageDialog";
import UpdateDishDataDialog from "../Common/UpdateDishDataDialog";

//Components
import CuisineMetaShow from "./CuisineMetaShow";
import CuisineIngredients from "./CuisineIngredients";

let cuisineDishService = new CuisineDishService();

const CuisineTabShow = ({
  activeTab,
  setActiveTab,
   onAddImage,
  onUpdate,
  onDelete,
}: any) => {

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const record = useRecordContext();

  return (
    <>

      <TabsContainer>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Details" />
          <Tab label="Ingredients" />
        </Tabs>
      </TabsContainer>

      <br />

      <>
        {activeTab === 0 && (
        <CuisineMetaShow
          onAddImage={onAddImage}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      )}
        {activeTab === 1 && <CuisineIngredients dishId={Number(record?.id)} />}
      </>
    </>
  );
};

const CuisineTypeBadge = ({ type }: { type: string }) => {
  const isVeg = type === "VEG";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 600,
        textTransform: "uppercase",
        backgroundColor: isVeg
          ? "rgba(46, 125, 50, 0.12)"
          : "rgba(211, 47, 47, 0.12)",
        color: isVeg ? "#2E7D32" : "#D32F2F",
      }}
    >
      {type}
    </Box>
  );
};


const CuisineShowHeader = () => {
  const record = useRecordContext();

  if (!record) return null;

  return (
    <WorkspaceHeader>
      <SectionTitleRow>
        <div
          style={{
            backgroundColor: "rgba(25, 117, 210, 0.1)",
            padding: "12px",
            borderRadius: "12px",
          }}
        >
          <CuisineIcon color={colors.primary} />
        </div>

        <div>
          <WorkspaceTitle>{record.name}</WorkspaceTitle>
        </div>
      </SectionTitleRow>
      
      {record?.type && <CuisineTypeBadge type={record.type} />}
      

    </WorkspaceHeader>
  );
};


const CuisineShow = (props: any) => {
  const [selectedData, setSelectedData] = useState<any>(null);
  const [openUploadImageDialog, setOpenUploadImageDialog] = useState(false);
  const [openUpdateDish, setOpenUpdateDish] = useState(false);

  const [activeTab, setActiveTab] = useState(0);

  const navigate = useNavigate()

  const handleDelete = (record: any) => {
    EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
      title: "Confirmation",
      message: "Are you sure you want to delete this dish?",
      onClose: (confirmed: boolean) => {
        if (!confirmed) return;

        cuisineDishService.deleteDish(record.id).then(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Deleted Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
          navigate("/CuisineDish");
        });
      },
    });
  };

  return (
    <WorkspaceContainer>

      <Show {...props} actions={false} sx={{
        backgroundColor: "transparent",
        "& .RaShow-card": {
          backgroundColor: "transparent",
          boxShadow: 'none',
        }
      }}>
        <CuisineShowHeader />
        {openUploadImageDialog && (
          <UploadDishImageDialog
            data={selectedData}
            open={openUploadImageDialog}
            callBack={() => setOpenUploadImageDialog(false)}
          />
        )}

        {openUpdateDish && (
          <UpdateDishDataDialog
            open={openUpdateDish}
            data={selectedData}
            setOpen={setOpenUpdateDish}
            callBack={() => {
              setOpenUpdateDish(false);
              setSelectedData(null);
            }}
          />
        )}

        <CuisineTabShow
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onAddImage={(record: any) => {
            setSelectedData(record);
            setOpenUploadImageDialog(true);
          }}
          onUpdate={(record: any) => {
            setSelectedData(record);
            setOpenUpdateDish(true);
          }}
          onDelete={handleDelete}
        />

        {openUploadImageDialog && (
          <UploadDishImageDialog
            data={selectedData}
            open
            callBack={() => setOpenUploadImageDialog(false)}
          />
        )}
        <br />
      </Show>
    </WorkspaceContainer>
  );
};

export default CuisineShow;